<h4>Période d'activation de votre {{ energy | energieName }}</h4>
@if (activeConsumptionPeriods) {
  <div>
    <ul>
      <li>
        <button class="btn btn-text" (click)="newPeriod()" matomoClickCategory="Consommations" matomoClickAction="click"
          matomoClickName="conso_ajouter_releve">
          <fa-icon [icon]="faPlus"></fa-icon>
          <span> Ajouter une nouvelle periode</span>
        </button>
      </li>
      @if (0===activeConsumptionPeriods.length) {
        <li style="border-bottom-color: {{ energieService.getColor(energy)}};">
          @if (energy === EnergieEnum.CHAUFFAGE) {
            Par défaut votre chauffage est actif du 15 octobre au
            30 avril
          }
          @if (energy === EnergieEnum.REFROIDISSEMENT) {
            Par défaut votre climatisation est active du 15 juin
            au 31 août
          }
        </li>
      }
      @for (period of activeConsumptionPeriods; track period) {
        <li
          style="border-bottom-color: {{ energieService.getColor(energy)}};">
          <div class="d-flex align-items-center">
            <div class="icon-container d-flex align-self-stretch align-items-center justify-content-center"
              style="background-color: {{ energieService.getColor(energy)}};">
              <div class="d-flex">
                <span class="icon {{energy|energieIcon}} color-light-blue" title="{{ energy | energieName }}"></span>
              </div>
            </div>
            <div class="value-container">
              Du {{ period.startDatePeriod | date }} <br/> Au {{ period.endDatePeriod | date }}
            </div>
            <div class="controls">
              @if (isEditable) {
                <button class="btn" title="Éditer le relevé" (click)="edit(period)">
                  <fa-icon [icon]="faPen" matomoClickCategory="Consommations" matomoClickAction="click"
                  matomoClickName="conso_releve_editer"></fa-icon>
                </button>
              }
              @if (isEditable) {
                <app-delete-confirm [message]="'Souhaitez-vous vraiment supprimer ce relevé ?'"
                  (deleted)="delete(period)" matomoClickCategory="Consommations" matomoClickAction="click"
                  matomoClickName="conso_releve_supprimer">
                  <button class="btn" title="Supprimer le relevé">
                    <fa-icon [icon]="faTimes"></fa-icon>
                  </button>
                </app-delete-confirm>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
}

<ng-template #modalPeriod>
  <div class="modal-body">
    <app-active-consumption-period-modal [period]="editPeriod" [logement]="logement" (periodRefresh)="onRefresh()"
    [energy]="energy"></app-active-consumption-period-modal>
  </div>
</ng-template>
